<template>
  <div
    class="ui placeholder segment file-dropper"
    @dragover.prevent
    @dragleave.prevent
    @drop.prevent="onDrop"
  >
    <div class="ui icon header">
      <i class="file outline icon"></i>
      <p>
        ファイルをここにドラッグ＆ドロップ
        <br />もしくは
        <br />
        <label class="ui button">
          ファイルを選択
          <input
            type="file"
            style="display:none;"
            multiple="multiple"
            @change="onDrop"
            ref="fileupload"
          />
        </label>
        <span class="file-limit-message">合計1GiBまで</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    onDrop: function (event) {
      const fileList = event.target.files
        ? event.target.files
        : event.dataTransfer.files
      let files = [...fileList]
      const itemList = event.dataTransfer ? event.dataTransfer.items : null
      let containsDirectory = false

      if (itemList && itemList.length > 0 && itemList[0].webkitGetAsEntry) {
        // DataTransferItemが使える場合は、ディレクトリを取り除く
        for (let idx = fileList.length - 1; idx >= 0; idx--) {
          const entry = itemList[idx].webkitGetAsEntry()
          if (entry.isDirectory) {
            files.splice(idx, 1)
          }
        }
        containsDirectory = fileList.length !== files.length
      }

      // イベントon-drop-fileを発火させて、files変数を親に渡す
      this.$emit('on-drop-file', files, containsDirectory)

      // リセット
      this.$refs.fileupload.value = ''
    }
  }
}
</script>

<style scoped>
.ui.placeholder.segment.file-dropper {
  border-style: dashed;
  border-width: 2px;
  text-align: center;
  padding: 10px;
  min-height: auto;
  min-width: auto;
}

.file-limit-message {
  font-size: 0.8em;
  font-weight: normal;
}
</style>
